import ApiService from "@/core/services/api.service";

const state = {
  meta: {},
  groups: [],
  response: {},
  isBusy: false,
};

const actions = {
  /**
   * @param context
   */
  getStaffGroup(context) {
    state.isBusy = true;
    context.commit("clearStaffGroup");
    ApiService.setHeader();

    console.log("State :", state);

    ApiService.query("/school/group/management", {
      params: {
        "page[number]": state.meta.current_page ?? 1,
        "page[size]": 20,
        id: 2,
      },
    })
      .then((response) => {
        context.commit("setStaffGroup", response);
        context.commit(
          "setStaffGroupPagination",
          response.data.meta.pagination
        );
      })
      .finally(() => (state.isBusy = false));
  },

  /**
   * Delete Staff group using GROUP ID.
   *
   * @param context
   * @param payload
   */
  deleteStaffGroup(context, payload) {
    ApiService.setHeader();

    const id = payload.id;
    console.log("ID", id);
    return ApiService.delete("school/group/management", {
      params: {
        id: id,
      },
    });
  },
};

const mutations = {
  /**
   * Set emp. group.
   *
   * @param state
   * @param response
   */
  setStaffGroup(state, response) {
    state.response = response;
    state.groups = response.data.data;
  },

  /**
   * Set group pagination.
   *
   * @param state
   * @param pagination
   */
  setStaffGroupPagination(state, pagination) {
    state.meta = pagination;
  },

  /**
   * Set page
   *
   * @param state
   * @param page
   */
  setStaffGroupPage(state, page) {
    console.log("Page: ", page);
    state.meta.current_page = page;
  },

  /**
   * Clear the group.
   *
   * @param state
   */
  clearStaffGroup(state) {
    state.groups = [];
  },
};

const getters = {
  getStaffGroup: (state) => state.groups,
  getStaffGroupPagination: (state) => state.meta,
};

export default {
  state,
  actions,
  mutations,
  getters,
};
